import InfiniteSearchableSelect from '../../../../components/ui/SearchableSelect/InfiniteSearchableSelect';
import { fetchBotNumberListPage } from '../../adapters/botNumberListAdapter';
import { mapBotToSelectOption } from '../../utils/normalizeTemplate';
import TemplateSearchableSelect from './TemplateSearchableSelect';

const isSameBot = (a, b) => (a?.wa_phone_number ?? a?.value) === (b?.wa_phone_number ?? b?.value);
const getBotId = (option) => option?.wa_phone_number ?? option?.value ?? option?.id ?? null;
const getBotLabel = (option) => option?.label ?? option?.wa_phone_number ?? '';

export default function TemplateBotNumberSearchableSelect({
  organisation,
  valueId = null,
  selectedBot = null,
  onChange,
  pageSize = 20,
  selectVariant = 'filter',
  ...props
}) {
  const organisationId = organisation?.organisation_id ?? organisation?.value ?? organisation;

  return (
    <InfiniteSearchableSelect
      {...props}
      extraParams={{ organisation_id: organisationId }}
      fetchPage={fetchBotNumberListPage}
      pageSize={pageSize}
      enabled={Boolean(organisationId)}
      loadOnOpen
      valueId={valueId}
      selectedSeed={selectedBot}
      mapToOption={mapBotToSelectOption}
      isSameOption={isSameBot}
      getOptionId={getBotId}
      getOptionLabel={getBotLabel}
      isOptionEqualToValue={isSameBot}
      onChange={onChange}
      SelectComponent={(selectProps) => (
        <TemplateSearchableSelect {...selectProps} variant={selectVariant} />
      )}
      placeholder={props.placeholder || 'Bot Number'}
      noOptionsText="No bot numbers found"
      disabled={props.disabled || !organisationId}
    />
  );
}
